import React from 'react';
import { CompanySchema } from './CompanySchema';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

const CompanyData = (props) => {
    const { block, data, onChangeBlock } = props;
    const schema = CompanySchema({ ...props });
    console.log(props.metadata);
    return (
        <BlockDataForm
            schema={schema}
            title={schema.title}
            onChangeField={(id, value) => {
                onChangeBlock(block, {
                    ...data,
                    [id]: value,
                });
            }}
            formData={data}
            block={block}
        />
    );
};
export default CompanyData;